export default "__VITE_ASSET__e708c0c4__"